import { render } from "./_TrainingRegistrationNotification.vue?vue&type=template&id=1ad0c6d5"
import script from "./_TrainingRegistrationNotification.vue?vue&type=script&lang=js"
export * from "./_TrainingRegistrationNotification.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__